<div class="flex flex-col gap-0 {{otherClasses}}">
  <span class="font-bold p-2 rounded-t-md text-secondary" *ngIf="key">{{ key }}</span>

    <span class="text-justify text-gray px-2 pb-1 {{useBottomBorder?'border-b-2 border-dotted border-primary-100':''}} text-gray-500">
      <span
        *ngIf="valueType != 'date' && valueType != 'number' && valueType != 'html'">{{ value | valueChecker }}</span>
      <span *ngIf="valueType == 'number'">{{ value | number }}</span>
      <span *ngIf="valueType == 'date'">{{ value | date }}</span>
      <span *ngIf="valueType == 'html'" [innerHtml]="value"></span>
    </span>

</div>
